import React from 'react';
import { useLocation } from '@reach/router';
import cn from 'classnames';
import { useInsightsShorts } from 'staticQueries/insights-shorts';
import Title from 'components/UI/Title';
import LazyImage from 'components/UI/LazyImage';
import VideoDuration from 'components/UI/VideoDuration';
import ExpertTalksModal from './ExpertTalksModal';
import { useStateModal } from 'utils/hooks';
import { observer, expertTalks as store } from 'store';
import { pushCustomEvent } from 'utils/analytics';

import * as styles from './ExpertTalks.module.scss';

function ExpertTalks({ filterByCategory, isThemeDark }) {
  const location = useLocation();
  const shorts = useInsightsShorts();
  const preparedShorts = getLatestShorts(shorts, filterByCategory);
  const textColor = isThemeDark ? 'white' : 'black';

  const { modalState, showModal, hideModal } = useStateModal();

  const handleOpenModal = i => {
    store.setCurrentIndex(i);
    showModal();
    store.setPlaying(true);
    pushCustomEvent('ndrsn_insights_shorts', {
      action: 'click_on_card',
      label: location.href,
    });
  };

  const handleCloseModal = () => {
    if (modalState.isOpen) {
      store.resetShortsStore();
    }
    store.setCurrentIndex(0);
    hideModal();
  };

  return (
    <>
      <section className={cn(styles.container, isThemeDark && styles.dark)}>
        {preparedShorts?.slice(0, 2).map(({ title, cover, expert, duration }, i) => (
          <article
            key={title}
            className={styles.card}
            role="button"
            onClick={() => handleOpenModal(i)}
          >
            <div className={styles.imgWrapper}>
              <LazyImage src={cover} className={styles.img} alt={expert} />
              <VideoDuration className={styles.duration} duration={duration} />
            </div>
            <div className={styles.caption}>
              <div className={styles.tag}>Expert Talks</div>
              <Title className={styles.title} size="md" color={textColor}>
                {title}
              </Title>
            </div>
          </article>
        ))}
      </section>
      {modalState.isOpen && (
        <ExpertTalksModal
          isOpen={modalState.isOpen}
          closeModalCallback={handleCloseModal}
          items={preparedShorts}
        />
      )}
    </>
  );
}

function getLatestShorts(shorts, filterByCategory) {
  if (filterByCategory) {
    return shorts?.filter(item => item.categories?.some(category => category === filterByCategory));
  }
  return shorts;
}

export default observer(ExpertTalks);
